






































































































































































































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import * as _ from 'lodash';
import moment from 'moment';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';

// 接口
import {
  queryParkingspacePackageList,
  queryParkingspacePackageDelete,
  queryParkingspacePackageAuditOrSale,
  queryParkingspacePackageEditInfo,
  editCService
} from '../../../api/parking-space-list';
import * as routeNames from '../router-names';
import Utils from '@root/utils/common';
import {
  packageUseTypeMap,
  shidaillPackageUseTypeMap,
  packageStateMap,
  packageTypeMap,
  categoryMap,
  packageFixedMap,
  weekDescList,
  packageCVerifyNewMap,
  optionalParkingNumberMap,
  packageCTypeMap,
  packagetCTypeMap
} from '../../../types/parking-space-management/dictionaries';

import { isShiDaill } from '@root/utils/env';

@Component({
  name: 'ChargingPackage',
  components: {
    ParkingLotSearch
  }
})
export default class ChargingPackage extends Mixins(TableMixin, TableWidthMixin) {
  //判断是否是时代邻里
  isshidaill: boolean = isShiDaill;

  // 车位用途
  useTypeList = this.isshidaill ? Utils.toLabelVal(shidaillPackageUseTypeMap) : Utils.toLabelVal(packageUseTypeMap);

  // 套餐状态
  stateList = Utils.toLabelVal(packageStateMap);

  // 星期中文
  private weekDescList = weekDescList;

  private packageTypeMap = packageTypeMap;

  // table数据
  private tableData: any[] = [];

  // 操作时间
  // private operateTime: any = []

  // 加载中
  loading: boolean = false;

  private filterParam: any = {
    parkId: [], // 车场ID集合,多车场逗号分隔
    useType: [], // 车位用途 01:产权 02:出租，多个用逗号隔开
    name: '', // 套餐名称
    // operateTimeStart: '', // 操作时间-开始
    // operateTimeEnd: '', // 操作时间-结束
    status: [] // 套餐状态 01:待审核 02:待售 03:审核未通过 04:在售中 05:已停售，多个用逗号隔开
  };
  private created() {
    this.fetchTableData();
  }
  /**
   * 点击搜索按钮
   */
  private search() {
    this.current = 1;
    this.fetchTableData();
  }

  // 清除搜索条件
  private onTableFilterClear({ defaultParkIdList }) {
    this.filterParam = {
      parkId: defaultParkIdList,
      useType: [],
      name: '',
      // operateTimeStart: '',
      // operateTimeEnd: '',
      status: []
    };
    // this.operateTime = []
    this.search();
  }

  /**
   * 获取列表数据
   */
  async fetchTableData() {
    if (this.loading) return;
    this.loading = true;
    try {
      const options = {
        ...this.filterParam,
        parkId: this.filterParam.parkId.join(','),
        // operateTimeStart:
        //   this.filterParam.operateTimeStart && moment(this.filterParam.operateTimeStart).format('YYYY-MM-DD HH:mm:ss'),
        // operateTimeEnd:
        //   this.filterParam.operateTimeEnd && moment(this.filterParam.operateTimeEnd).format('YYYY-MM-DD HH:mm:ss'),
        useType: this.filterParam.useType.join(','),
        status: this.filterParam.status.join(','),
        currPage: this.current,
        pageSize: this.pageSize
      };
      const { status, code, msg, data } = await queryParkingspacePackageList({ ...options });
      const { datas = [], totalNum = 0, total = {} } = data || {};
      this.tableData = datas;
      this.total = Number(totalNum);
    } catch (error) {
      this.$message.error(error.msg);
    } finally {
      this.loading = false;
    }
  }

  // 入场时间改变
  onEnterTimeChange(date: any, dateString: any) {
    let [startTime, endTime] = dateString;
    // this.filterParam.operateTimeStart = startTime
    // this.filterParam.operateTimeEnd = endTime
  }

  get tableColums() {
    return [
      {
        title: '序号',
        width: 55,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '套餐名称',
        dataIndex: 'name',
        width: 180,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '授权区域',
        dataIndex: 'packageArea',
        width: 210,
        scopedSlots: { customRender: 'packageArea' }
      },
      {
        title: '车位用途',
        dataIndex: 'useType',
        width: 180
        // customRender: (text: any) => packageUseTypeMap[text],
      },
      {
        title: '是否固定车位',
        dataIndex: 'fixed',
        width: 180,
        customRender: (text: any) => packageFixedMap[text]
      },
      {
        title: '套餐类型',
        dataIndex: 'type',
        width: 180,
        scopedSlots: { customRender: 'type' }
      },
      {
        title: '授权周期(月)',
        dataIndex: 'period',
        width: 180
      },
      {
        title: '套餐价格(元)',
        dataIndex: 'price',
        width: 180
      },
      {
        title: '套餐状态',
        dataIndex: 'status',
        width: 100,
        customRender: (text: any) => packageStateMap[text]
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
        fixed: 'right',
        width: 240
      }
    ];
  }

  // 发售
  private async toCheckSale(packageId: string, status: string, text: string) {
    this.$confirm({
      title: `你确定${text}？`,
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        try {
          const { data } = await queryParkingspacePackageAuditOrSale({
            packageId,
            status
          });
          this.$message.success(`${text}成功`);
          this.fetchTableData();
        } catch (error) {
          this.$message.error(error.msg);
        }
      },
      onCancel() {}
    });
  }

  // 审核
  private async toCheckResult(packageId: string, status: string) {
    try {
      const { data } = await queryParkingspacePackageAuditOrSale({
        packageId,
        status
      });
      this.$message.success('操作成功');
      this.fetchTableData();
    } catch (error) {
      this.$message.error(error.msg);
    }
  }
  // 去修改
  private toEdit(id: string) {
    this.$router.push({
      name: routeNames.CHARGING_PACKAGE_UPDATE,
      params: {
        id
      }
    });
  }

  // 去详情
  private toDetail(id: string) {
    this.$router.push({
      name: routeNames.CHARGING_PACKAGE_DETAIL,
      params: {
        id
      }
    });
  }

  // 去添加
  private toAddPage() {
    this.$router.push({
      name: routeNames.CHARGING_PACKAGE_ADD
    });
  }

  // 删除
  private async toDelete(id: string) {
    this.$confirm({
      title: '你确定删除？',
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        try {
          const { data } = await queryParkingspacePackageDelete({
            packageId: id
          });
          this.$message.success('删除成功');
          this.fetchTableData();
        } catch (error) {
          this.$message.error(error.msg);
        }
      },
      onCancel() {}
    });
  }
  getCharCount(str) {
    if (!str) return 0;
    str = str.split(',');
    return str.length;
  }

  // c端配置
  packageCVerifyNewList = Utils.toLabelVal(packageCVerifyNewMap);
  OptionalParkingNumberList = Utils.toLabelVal(optionalParkingNumberMap);
  packageCTypeList = Utils.toLabelVal(packageCTypeMap);
  configurationVisible = false;
  callocationList = {
    cType: [],
    cVerifyNew: '01',
    choiceSpace: '01'
  };

  useTypeCode = '';
  packageId = '';
  subList: any = {};
  showC(row) {
    const { useTypeCode, packageId } = row;
    this.useTypeCode = useTypeCode;
    if (useTypeCode == '01') {
      this.packageCTypeList = Utils.toLabelVal(packagetCTypeMap);
    } else {
      this.packageCTypeList = Utils.toLabelVal(packageCTypeMap);
    }
    this.packageId = packageId;
    this.configurationVisible = true;
    this.getPackageEditInfo();
  }
  async getPackageEditInfo() {
    // 获取数据
    try {
      const { data } = await queryParkingspacePackageEditInfo({
        packageId: this.packageId
      });
      const { cType = [], cVerifyNew = '', choiceSpace = '' } = data;
      this.subList = data;
      // delete this.subList.cVerifyNew;
      this.callocationList.cType = cType;
      this.callocationList.cVerifyNew = cVerifyNew || '';
      this.subList.cVerifyNew = cVerifyNew || '';
      this.callocationList.choiceSpace = choiceSpace || '';
      this.subList.choiceSpace = choiceSpace || '';
      console.log(this.subList, data, 'na dao le ');
      // console.log(res, 'na dao le ', cVerifyNew, choiceSpace);
    } catch (error) {
      this.$message.error(error.msg);
    }
  }
  // 提交
  handleOk() {
    // 判断
    console.log(this.subList);
    console.log(
      // this.subList.cType.join(',') === this.callocationList.cType.join(',')
      // &&
      this.subList.cVerifyNew === this.callocationList.cVerifyNew,
      this.subList.cVerifyNew,
      this.callocationList.cVerifyNew,
      // &&
      this.subList.choiceSpace === this.callocationList.choiceSpace,
      this.subList.choiceSpace,
      this.callocationList.choiceSpace
    );
    if (
      this.subList.cType.length === this.callocationList.cType.length &&
      this.subList.cType.join(',') === this.callocationList.cType.join(',') &&
      this.subList.cVerifyNew === this.callocationList.cVerifyNew &&
      this.subList.choiceSpace === this.callocationList.choiceSpace
    ) {
      console.log('dddddddd,jin lai le ddddd');
      return this.$message.warning('您尚未进行任何修改，请确认后再提交');
    }
    try {
      let params = {
        pkPackageId: this.packageId,
        cType: this.callocationList.cType.join(','),
        cVerifyNew: this.callocationList.cVerifyNew,
        choiceSpace: this.callocationList.choiceSpace
      };
      if (this.useTypeCode === '01' || this.callocationList.cType.indexOf('01') === -1) {
        delete params.cVerifyNew;
        delete params.choiceSpace;
      } else {
        if (this.callocationList.cVerifyNew === '') {
          return this.$message.warning('C端开卡是否需要审核请选择');
        }
        if (this.callocationList.choiceSpace === '') {
          return this.$message.warning('C端开卡用户是否可自选车位号请选择');
        }
        params.cVerifyNew = this.callocationList.cVerifyNew;
        params.choiceSpace = this.callocationList.choiceSpace;
      }
      const res = editCService({ ...this.subList, ...params });
      this.handleCancel();
      this.$message.success('修改成功');
    } catch (e) {
      console.log(e);
      this.$message.success((e && e.msg) || '修改失败');
    }
  }
  handleCancel() {
    this.configurationVisible = false;
    this.callocationList = {
      cType: [],
      cVerifyNew: '01',
      choiceSpace: '01'
    };
  }
}
